import _values from 'lodash/values';

const fieldLayouts = {
  TOP:      'template:common:form:field.vertical.top',
  CENTERED: 'template:common:form:field.vertical.center',
  LEFT:     'template:common:form:field.horizontal.left',
};

const seImgPath = `${App.globalContext.assetURL}c/img/screen-designer/section-editor`;

const fieldLayoutsList = [
  {
    text:   'Left',
    byline: 'Labels on left above field',
    image:  seImgPath + '/layout-form-top.svg',
    value:  fieldLayouts.TOP,
  },
  {
    text:   'Centered',
    byline: 'All elements centered',
    image:  seImgPath + '/layout-form-center.svg',
    value:  fieldLayouts.CENTERED,
  },
];

const fieldLayoutsAll = _values(fieldLayouts);

export { fieldLayouts, fieldLayoutsList, fieldLayoutsAll };

export default fieldLayouts;
